import { render, staticRenderFns } from "./CallsTableHeader.vue?vue&type=template&id=a90c333c&"
import script from "./CallsTableHeader.vue?vue&type=script&lang=ts&"
export * from "./CallsTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports